import BaseForm from '../base';
export class WeatherPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
